import { FC, MouseEvent, ReactNode } from "react";
import { TypeToastMessage } from "../lib/types";

interface BookingToastProps extends TypeToastMessage {
  icon: ReactNode;
  toggle: () => void;
}

/**
 * This function user to show the add to Booking toast
 *
 * @param {*} props
 * @return {*}
 */
const BookingToastView: FC<BookingToastProps> = (props) => {
  const { icon, open = false, type, message, toggle } = props;

  const handleButtonClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    toggle();
  };

  return (
    <div
      className={`alert alert-${type} alert-toast ${open ? "active visible" : "hidden"}`}
      role="alert"
    >
      {icon}
      <div className="alert-text">{message}</div>
      <button className="btn btn-close z-3" onClick={handleButtonClick} />
    </div>
  );
};

export default BookingToastView;
